import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';
import { MenuItemPublicDto } from 'src/app/modules/header/components/menu-categorias-b2c/dtos';

import { MenuMapper } from '../../../../modules/header/components/menu-categorias-b2c/mappers';
import { MenuItem } from 'src/app/modules/header/components/menu-categorias-b2c/models';

const API_CMS = `${environment.apiEcommerce}/api/v1/cms`;

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly menuMapper: MenuMapper = inject(MenuMapper);

  /**
   * Obtener categorías del menú.
   * @returns
   */
  getMenuCategories(): Observable<MenuItem> {
    return this.http
      .get<MenuItemPublicDto>(`${API_CMS}/categories-menu`)
      .pipe(map((dtos) => this.menuMapper.mapMenuDtoToMenuItem(dtos)));
  }
}
